import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardOverviewRoute extends Route {}

export default instrumentRoutePerformance(PlanningDashboardOverviewRoute);
